import React from "react";
import { Context } from "../../context";
import { GatsbyImage } from "gatsby-plugin-image";
import decodeHTMLEntities from "../../../utils/decodeHTMLentities";
import HTMLParser from "../../htmlParser";
const Image = (props) => {
    const { allImages } = React.useContext(Context);
    const targetImage = props.targetImage ||
        allImages.find((e) => {
            if (props.attributes.id) {
                return e.databaseId.toString() === props.attributes.id.toString();
            }
            if (props.attributes.url) {
                return e.sourceUrl === props.attributes.url;
            }
        });
    const sizeSlug = props.size || "xl";
    const align = props.attributes.align && props.attributes.align.length
        ? "align" + props.attributes.align
        : undefined;
    const ImageRender = () => {
        if (!targetImage) {
            return (React.createElement("img", { id: props.anchor || props.attributes.anchor, style: props.attributes.style, className: align, src: props.attributes.url, alt: decodeHTMLEntities(props.attributes.altText ||
                    props.attributes.caption) }));
        }
        return (React.createElement(GatsbyImage, { id: props.anchor || props.attributes.anchor, className: align, style: props.attributes.style, ...props.gatsbyImageOptions, image: targetImage.localFile.childImageSharp[sizeSlug], alt: decodeHTMLEntities(props.attributes.altText ||
                targetImage?.altText ||
                props.attributes?.caption ||
                targetImage?.caption) }));
    };
    return (React.createElement("figure", { className: [
            "gatsby-image-wrapper",
            (align || ""),
            (props.attributes.className || ""),
            (props.className || "")
        ].join(" "), onClick: props.onClick },
        React.createElement(ImageRender, null),
        props.attributes.caption ? (React.createElement("figcaption", null,
            props.attributes.title ? (React.createElement("span", { className: "title-figcaption" }, props.attributes.title)) : (React.createElement(React.Fragment, null)),
            React.createElement(HTMLParser, null, props.attributes.caption))) : (React.createElement(React.Fragment, null))));
};
export default Image;
